<template>
  <div>
    <v-carousel height="auto">
      <v-carousel-item
        v-for="(image, index) in images"
        :key="index"
        :src="image"
        :aspect-ratio="16/9"
      />
    </v-carousel>
    <v-row no-gutters>
      <v-col
        v-for="(image, index) in images"
        :key="index"
        cols="2"
      >
        <v-img
          :src="image"
          :aspect-ratio="16/9"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CCarImages',
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
</script>
